import { DEFAULT_PAGE } from "../../contstants";
import { GetProgramReports } from "./getProgramReports";

const FilterProgramReports = async (perPage, filters) => {
  const page = filters.page || DEFAULT_PAGE;
  const status = filters.status || "";
  const id = filters.program_id || "";

  let statusFilter = true;
  if (status === "inactive") {
    statusFilter = false;
  }
  if (!id) {
    return {
      data: [],
      total: 0,
      page: 1,
      perPage: 10,
    };
  }
  return await GetProgramReports(
    id,
    perPage,
    (page - 1) * perPage,
    statusFilter
  );
};

export default FilterProgramReports;
